module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/312.6b13f6f9.png";